import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import type { TsTypeType, TsCodeType } from '../types.js'
import type { VariableNameType } from '../types.js'
import { LowgileAction } from '../script/lowgile-action.js'
import {
	jsonArrayProperty,
	jsonClass,
	jsonProperty,
} from '@sumbricht/json-class-serializer'
import { BoVisitor } from '../bos/bo-visitor.js'

export const StoreSources = ['static', 'dataquery'] as const

@jsonClass('StoreProperty')
export class StoreProperty {
	@jsonProperty(String) name!: VariableNameType
	@jsonProperty(String) type!: TsTypeType
	@jsonProperty(Boolean) isMultiple: boolean = false
	@jsonProperty(String) source: (typeof StoreSources)[number] = 'static'
	@jsonProperty(String) sourceExpression: TsCodeType = ''
	@jsonProperty(String) sourceDataQuery: string = ''

	constructor(init?: Partial<StoreProperty>) {
		assignCommonProperties(this, init)
	}
}

@jsonClass('Store')
export class Store {
	@jsonArrayProperty(StoreProperty)
	properties: StoreProperty[] = []

	@jsonArrayProperty(LowgileAction)
	actions: LowgileAction[] = []

	visit(visitor: BoVisitor, pathPrefix: (string | number)[]): void {
		this.properties?.forEach((property, idx) => {
			visitor.visitTsCode(
				property.type,
				property,
				'type',
				[...pathPrefix, idx, 'type'],
				(newType) => (property.type = newType),
			)
			visitor.visitTsCode(
				property.sourceExpression,
				property,
				'property',
				[...pathPrefix, idx, 'sourceExpression'],
				(newCode) => (property.sourceExpression = newCode),
			)
		})
		this.actions.forEach((action, idx) =>
			action.visit(visitor, [...pathPrefix, 'action', idx]),
		)
	}
}
